$shm_ba_posts $mol_view
	table null
	table_count 0
	highlight \
	sort? \Дата
	sort_order? \desc
	page? 0
	page_size? \25
	sub <= post_rows /
		<= Title $mol_view
			sub <= title_content /
		<= Page_tools $mol_view
			sub <= page_tools /
				<= Page_numbers $mol_view
					sub <= page_number_rows /
						<= Page_number* $shm_ba_posts_page_button
							title <= page_number_title* \
							current <= page_number_current* false
							click? <=> page_pick*? null
						<= Page_gap* $mol_view
							sub /
								\...
				<= Page_info $mol_view
					sub /
						<= page_info \
				<= Page_size_label $mol_labeler
					title \Показывать:
					Content <= Page_size $mol_select
						Filter null
						value? <=> page_size? \25
						options <= page_size_options /
						dictionary <= page_size_dict *
		<= Title_spacer $mol_view
		<= Page_tools_bottom $mol_view
			sub <= page_tools_bottom /
				<= Page_numbers_bottom $mol_view
					sub <= page_number_rows_bottom /
						<= Page_number_bottom* $shm_ba_posts_page_button
							title <= page_number_title* \
							current <= page_number_current* false
							click? <=> page_pick*? null
						<= Page_gap_bottom* $mol_view
							sub /
								\...
				<= Page_info_bottom $mol_view
					sub /
						<= page_info \
				<= Page_size_label_bottom $mol_labeler
					title \Показывать:
					Content <= Page_size_bottom $mol_select
						Filter null
						value? <=> page_size? \25
						options <= page_size_options /
						dictionary <= page_size_dict *
	Sort_button* $shm_ba_posts_sort_button
		title <= sort_title* \
		current <= sort_current* false
		click? <=> sort_pick*? null
	More_sort $mol_pick
		trigger_content /
			\Еще
		bubble_content /
			<= More_sort_list $mol_list
				rows <= more_sort_buttons /
	Post* $shm_ba_post_card
		post_row <= post_row* null
		table <= table null
		highlight <= highlight

$shm_ba_posts_sort_button $mol_button_minor
	current false
	attr *
		^
		shm_ba_posts_sort_current <= current
	sub /
		<= title
	event *
		^
		click? <=> click? null

$shm_ba_posts_page_button $mol_button_minor
	current false
	attr *
		^
		shm_ba_posts_page_current <= current
	sub /
		<= title
	event *
		^
		click? <=> click? null
